import ButtonGroup from './buttonGroup/ButtonGroup';
import ChartGroup from './chartGroup/ChartGroup';
import Spinner from '../../ui/spinner/index';
import { useLocalization } from 'src/utils/useLocalization';
import React, { useState } from 'react';

import './body.scss';

export interface ICreditDataset {
    approved?: number;
    pending?: number;
    declined?: number;
    conditioned?: number;
    withdrawn?: number;
}

export interface IFundingDataset {
    approved?: number;
    received?: number;
    declined?: number;
    booked?: number;
    withdrawn?: number;
}

const Body: React.FC<{
    brand: string;
    creditDataset?: ICreditDataset;
    fundingDataset?: IFundingDataset;
}> = ({ brand, creditDataset, fundingDataset }) => {
    const { statusSummary } = useLocalization();
    const [creditWidgetVisibility, showCreditWidget] = useState<boolean>(false);
    const loader = (
        <div className='loader_container'>
            <Spinner />
        </div>
    );
    let creditChart = loader;
    let fundingChart = loader;

    function buttonHanlder(id: string) {
        if (
            (id === 'credit' && !creditWidgetVisibility) ||
            (id === 'funding' && creditWidgetVisibility)
        ) {
            showCreditWidget(!creditWidgetVisibility);
        }
    }

    const colors = {
        approved: '#029640',
        pending: '#363b49',
        declined: '#e4002c',
        withdrawn: '#d1dcde',
        conditioned: '#ffd100',
        booked: '#5585b9',
    };

    if (creditDataset) {
        const creditData = {
            labels: [
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_APPROVED,
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_PENDING,
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_DECLINED,
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_CONDITIONED,
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_WITHDRAWN,
            ],
            data: [
                normalize(creditDataset.approved),
                normalize(creditDataset.pending),
                normalize(creditDataset.declined),
                normalize(creditDataset.conditioned),
                normalize(creditDataset.withdrawn),
            ],
            colors: [
                colors.approved,
                colors.pending,
                colors.declined,
                colors.conditioned,
                colors.withdrawn,
            ],
            product: statusSummary.LABEL_STATUS_SUMMARY_CREDIT_PRODUCT,
        };
        creditChart = <ChartGroup data={creditData} />;
    }

    if (fundingDataset) {
        const fundingData = {
            labels: [
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_APPROVED,
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_RECEIVED,
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_UNABLETOFUND,
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_BOOKED,
                statusSummary.LABEL_STATUS_SUMMARY_ITEM_WITHDRAWN,
            ],
            data: [
                normalize(fundingDataset.approved),
                normalize(fundingDataset.received),
                normalize(fundingDataset.declined),
                normalize(fundingDataset.booked),
                normalize(fundingDataset.withdrawn),
            ],
            colors: [
                colors.approved,
                colors.pending,
                colors.declined,
                colors.booked,
                colors.withdrawn,
            ],
            product: statusSummary.LABEL_STATUS_SUMMARY_FUNDING_PRODUCT,
        };
        fundingChart = <ChartGroup data={fundingData} />;
    }

    return (
        <div className='status-summary-body'>
            <ButtonGroup
                brand={brand}
                handler={buttonHanlder}
                isCreditSelected={creditWidgetVisibility}
            />
            {creditWidgetVisibility ? creditChart : null}
            {creditWidgetVisibility ? null : fundingChart}
        </div>
    );
};

function normalize(value: any) {
    const defaultValue = 0;
    return isNaN(value) ? defaultValue : value;
}

export default Body;
